import { Translation, getTranslationsEmpty } from '@/models/translation';

import { Currency } from './currency';

export interface QueryMarket {
    id: string;
}

export interface StoreMarket {
    id: string;
    name: string;
    currencyCode: string;
    currencySymbol: string;
}

export interface Market {
    id: string;
    name: string;
    currency: Currency;
    translations: Translation[];
    createdAt?: string;
    updatedAt?: string | null;
}

export interface MarketPayload {
    id?: string;
    name: string;
    currency: Currency | null;
    translations: Translation[];
}

export function getEmptyMarket(): MarketPayload {
    return {
        id: undefined,
        name: '',
        currency: null,
        translations: getTranslationsEmpty(['name']),
    };
}

export function castStoreMarketToMarketPayload(storeMarket?: StoreMarket): MarketPayload {
    return {
        id: storeMarket?.id,
        name: storeMarket?.name ?? '',
        currency: storeMarket?.currencyCode
            ? {
                  code: storeMarket.currencyCode,
                  name: '',
                  symbol: storeMarket.currencySymbol,
              }
            : null,
        translations: getTranslationsEmpty(['name']),
    };
}

export function castMarketToStoreMarket(market: Market): StoreMarket {
    return {
        id: market.id,
        name: market.name,
        currencyCode: market.currency.code,
        currencySymbol: market.currency.symbol,
    };
}
